import { createContext } from "react";
import type { IWorkflowNodeContext } from "../index";

const NodeContext = createContext<IWorkflowNodeContext>(
  {} as IWorkflowNodeContext
);

export default NodeContext;
